(function(){
  function init(root){
    if(root.__sgf)return; root.__sgf=1;
    var stage=root.querySelector('[data-sgf-stage]');
    var cards=[].slice.call(root.querySelectorAll('[data-sgf-card]'));
    var n=cards.length;
    var dotsBox=root.querySelector('[data-sgf-dots]');
    var hint=root.querySelector('[data-sgf-hint]');
    var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!n){root.style.display='none';return;}
    var order=cards.map(function(_,i){return i;});
    var dx=0,drag=false,out=0,busy=false,moved=false,sx=0,sy=0,vert=false,m={};
    var dots=cards.map(function(c,i){
      var b=document.createElement('button');b.type='button';b.className='sgf__dot';
      b.setAttribute('aria-label','Ir a '+((c.querySelector('.sgf__title')||{}).textContent||('tarjeta '+(i+1))));
      b.addEventListener('click',function(){bring(i);});
      dotsBox.appendChild(b);return b;});
    if(n<2){root.querySelector('.sgf__ctl').style.display='none';hint.style.display='none';}
    function measure(){
      var vw=window.innerWidth||1100,mob=vw<640;
      var cw=mob?Math.min(Math.round(vw*.58),250):300;
      var ch=Math.round(cw*1.42);
      m={mob:mob,cw:cw,ch:ch,ang:mob?8:12,limit:mob?60:90};
      stage.style.height=Math.round(ch*1.2)+'px';
      root.style.setProperty('--sgf-pad',(mob?16:24)+'px');
      root.style.setProperty('--sgf-ts',(mob?20:28)+'px');
      root.style.setProperty('--sgf-bh',(mob?34:40)+'px');
      root.style.setProperty('--sgf-bp',(mob?14:18)+'px');
      root.style.setProperty('--sgf-bf',(mob?13:14.5)+'px');
      hint.textContent=mob?(root.getAttribute('data-hint-mobile')||''):(root.getAttribute('data-hint-desktop')||'');
      cards.forEach(function(c){c.style.width=cw+'px';c.style.height=ch+'px';c.style.marginLeft=(-cw/2)+'px';c.style.top=Math.round(ch*.1)+'px';c.style.borderRadius=(mob?22:28)+'px';});
    }
    function render(){
      cards.forEach(function(c,idx){
        var p=order.indexOf(idx),rot=0,ty=0,sc=1,tx=0,z=40-p*10;
        if(p===1){rot=m.ang;sc=.97;ty=m.ch*.02;}
        else if(p===2){rot=-m.ang;sc=.97;ty=m.ch*.02;}
        else if(p>=3){sc=.9;ty=-m.ch*.09;}
        var tr='transform .6s cubic-bezier(.23,1,.32,1)';
        if(p===0){
          if(out){tx=out*m.cw*1.15;rot=out*16;sc=.96;tr='transform .32s cubic-bezier(.4,0,.8,.5)';}
          else{tx=dx;rot=dx/20;if(drag)tr='none';}
        }
        c.style.transition=reduce?'none':tr;
        c.style.transform='translate('+tx+'px,'+ty+'px) rotate('+rot+'deg) scale('+sc+')';
        c.style.zIndex=z;
        c.style.cursor=p===0?(drag?'grabbing':'grab'):'pointer';
        c.setAttribute('tabindex',p===0?'0':'-1');
        c.setAttribute('aria-hidden',p===0?'false':'true');
      });
      dots.forEach(function(d,i){d.classList.toggle('is-on',i===order[0]);});
    }
    function advance(dir){
      if(busy||n<2)return;busy=true;drag=false;out=dir;dx=0;render();
      setTimeout(function(){order.push(order.shift());out=0;dx=0;busy=false;render();},reduce?0:320);
    }
    function back(){if(busy||n<2)return;order.unshift(order.pop());dx=0;drag=false;render();}
    function bring(i){
      if(busy)return;var g=0;while(order[0]!==i&&g<20){order.push(order.shift());g++;}
      dx=0;drag=false;render();
    }
    function finish(){
      if(!drag)return;
      if(Math.abs(dx)>m.limit)advance(dx>0?1:-1);else{drag=false;dx=0;render();}
    }
    cards.forEach(function(c,idx){
      function front(){return order[0]===idx;}
      c.addEventListener('dragstart',function(e){e.preventDefault();});
      c.addEventListener('pointerdown',function(e){
        if(!front()||busy||e.pointerType==='touch'||(e.button&&e.button!==0))return;
        sx=e.clientX;moved=false;drag=true;dx=0;render();});
      c.addEventListener('pointermove',function(e){
        if(!front()||!drag||e.pointerType==='touch')return;
        var d=e.clientX-sx;
        if(!moved&&Math.abs(d)>6){moved=true;try{c.setPointerCapture(e.pointerId);}catch(_){}}
        if(moved){dx=d;render();}});
      function pup(e){if(!front()||!drag||(e&&e.pointerType==='touch'))return;finish();}
      c.addEventListener('pointerup',pup);c.addEventListener('pointercancel',pup);
      c.addEventListener('touchstart',function(e){
        if(!front()||busy||!e.touches||!e.touches[0])return;
        sx=e.touches[0].clientX;sy=e.touches[0].clientY;moved=false;vert=false;drag=true;dx=0;render();},{passive:true});
      c.addEventListener('touchmove',function(e){
        if(!front()||!drag||vert||!e.touches||!e.touches[0])return;
        var d=e.touches[0].clientX-sx,v=e.touches[0].clientY-sy;
        if(!moved&&Math.abs(v)>Math.abs(d)&&Math.abs(v)>8){vert=true;drag=false;dx=0;render();return;}
        if(Math.abs(d)>6)moved=true;
        if(moved){dx=d;render();}},{passive:true});
      function tend(){if(!front()||!drag)return;finish();}
      c.addEventListener('touchend',tend);c.addEventListener('touchcancel',tend);
      c.addEventListener('click',function(e){
        if(moved){e.preventDefault();moved=false;return;}
        if(!front()){e.preventDefault();bring(idx);}
      });
      c.addEventListener('keydown',function(e){
        if(e.key==='ArrowRight'){e.preventDefault();advance(1);}
        else if(e.key==='ArrowLeft'){e.preventDefault();back();}
      });
    });
    root.querySelector('[data-sgf-prev]').addEventListener('click',back);
    root.querySelector('[data-sgf-next]').addEventListener('click',function(){advance(1);});
    var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){measure();render();},80);});
    measure();render();
  }
  function all(){[].forEach.call(document.querySelectorAll('[data-sgf]'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();
